import './App.css';

function App() {
  return (
    <div className="App">
      <section className="hero-section">
        <div className="corp-grid"></div>
        
        <div className="location-block">
          <div className="location-primary">Kor</div>
          <div className="location-secondary">Korcuda</div>
        </div>

      </section>

      <section className="writing-section" id="writing">
        <article className="article">
          <div className="article-body">
            <p>
              ->
            </p>
            
          </div>
        </article>
      </section>
    </div>
  );
}

export default App;
